// The agent name registered in the Copilot runtime (copilot-runtime/, AGENT_ID).
// Kept free of React/CopilotKit imports so plain utilities and tests can use it.
export const AI_CHAT_AGENT_ID = 'modugen'
